import { t } from "i18next";

// Note: Components using this file must provide the `t` function from react-i18next
// (e.g., via useTranslation hook) to resolve translations.

const riskLevelColor = {
  1: {
    1: { backgroundColor: "green", color: "white" },
    2: { backgroundColor: "green", color: "white" },
    3: { backgroundColor: "yellow", color: "black" },
    4: { backgroundColor: "yellow", color: "black" },
    5: { backgroundColor: "yellow", color: "black" },
  },
  2: {
    1: { backgroundColor: "green", color: "white" },
    2: { backgroundColor: "yellow", color: "black" },
    3: { backgroundColor: "yellow", color: "black" },
    4: { backgroundColor: "orange", color: "white" },
    5: { backgroundColor: "orange", color: "white" },
  },
  3: {
    1: { backgroundColor: "yellow", color: "black" },
    2: { backgroundColor: "yellow", color: "black" },
    3: { backgroundColor: "orange", color: "white" },
    4: { backgroundColor: "orange", color: "white" },
    5: { backgroundColor: "red", color: "white" },
  },
  4: {
    1: { backgroundColor: "yellow", color: "black" },
    2: { backgroundColor: "orange", color: "white" },
    3: { backgroundColor: "orange", color: "white" },
    4: { backgroundColor: "red", color: "white" },
    5: { backgroundColor: "red", color: "white" },
  },
  5: {
    1: { backgroundColor: "yellow", color: "black" },
    2: { backgroundColor: "orange", color: "white" },
    3: { backgroundColor: "red", color: "white" },
    4: { backgroundColor: "red", color: "white" },
    5: { backgroundColor: "red", color: "white" },
  },
};

const riskLevelData = {
  1: {
    1: t("riskMatrix.riskLevelLow"),
    2: t("riskMatrix.riskLevelLow"),
    3: t("riskMatrix.riskLevelModerate"),
    4: t("riskMatrix.riskLevelModerate"),
    5: t("riskMatrix.riskLevelModerate"),
  },
  2: {
    1: t("riskMatrix.riskLevelLow"),
    2: t("riskMatrix.riskLevelModerate"),
    3: t("riskMatrix.riskLevelModerate"),
    4: t("riskMatrix.riskLevelCritical"),
    5: t("riskMatrix.riskLevelCritical"),
  },
  3: {
    1: t("riskMatrix.riskLevelModerate"),
    2: t("riskMatrix.riskLevelModerate"),
    3: t("riskMatrix.riskLevelCritical"),
    4: t("riskMatrix.riskLevelCritical"),
    5: t("riskMatrix.riskLevelIntolerable"),
  },
  4: {
    1: t("riskMatrix.riskLevelModerate"),
    2: t("riskMatrix.riskLevelCritical"),
    3: t("riskMatrix.riskLevelCritical"),
    4: t("riskMatrix.riskLevelIntolerable"),
    5: t("riskMatrix.riskLevelIntolerable"),
  },
  5: {
    1: t("riskMatrix.riskLevelModerate"),
    2: t("riskMatrix.riskLevelCritical"),
    3: t("riskMatrix.riskLevelIntolerable"),
    4: t("riskMatrix.riskLevelIntolerable"),
    5: t("riskMatrix.riskLevelIntolerable"),
  },
};

const getProbabilityList = (t) => [
  { value: 1, label: t("riskMatrix.probabilityVeryUnlikely") },
  { value: 2, label: t("riskMatrix.probabilityUnlikely") },
  { value: 3, label: t("riskMatrix.probabilityPossible") },
  { value: 4, label: t("riskMatrix.probabilityLikely") },
  { value: 5, label: t("riskMatrix.probabilityVeryLikely") },
];

const getSeverityPeople = (t) => [
  { value: 1, label: t("riskMatrix.severityPeopleSlight") },
  { value: 2, label: t("riskMatrix.severityPeopleMinor") },
  { value: 3, label: t("riskMatrix.severityPeopleMajor") },
  { value: 4, label: t("riskMatrix.severityPeopleSingleFatality") },
  { value: 5, label: t("riskMatrix.severityPeopleMultipleFatalities") },
];

const getSeverityEnvironment = (t) => [
  { value: 1, label: t("riskMatrix.severityEnvironmentSlight") },
  { value: 2, label: t("riskMatrix.severityEnvironmentMinor") },
  { value: 3, label: t("riskMatrix.severityEnvironmentLocal") },
  { value: 4, label: t("riskMatrix.severityEnvironmentMajor") },
  { value: 5, label: t("riskMatrix.severityEnvironmentMassive") },
];

const getSeverityAsset = (t) => [
  { value: 1, label: t("riskMatrix.severityAssetSlight") },
  { value: 2, label: t("riskMatrix.severityAssetMinor") },
  { value: 3, label: t("riskMatrix.severityAssetLocal") },
  { value: 4, label: t("riskMatrix.severityAssetMajor") },
  { value: 5, label: t("riskMatrix.severityAssetMassive") },
];

const getSeverityReputation = (t) => [
  { value: 1, label: t("riskMatrix.severityReputationSlight") },
  { value: 2, label: t("riskMatrix.severityReputationLimited") },
  { value: 3, label: t("riskMatrix.severityReputationConsiderable") },
  { value: 4, label: t("riskMatrix.severityReputationMajorNational") },
  { value: 5, label: t("riskMatrix.severityReputationMajorInternational") },
];

const SelectListData = () => {
  return null;
};

export {
  SelectListData,
  riskLevelData,
  riskLevelColor,
  getSeverityPeople,
  getSeverityEnvironment,
  getSeverityAsset,
  getSeverityReputation,
  getProbabilityList,
};
